import { inject, Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import { map } from 'rxjs';
import { UtilService } from '../services/util.service';
import { GraphqlClientType } from './graphql.provider';
import {
  GetCurrentUserQueueWithPaginationQueryInput,
  GetResellerQueueWithPaginationQueryInput,
  GetUserQueueWithPaginationQueryInput,
  GetUsersQueueWithPaginationQueryInput,
} from './scheduledMessages.api';

@Injectable({
  providedIn: 'root',
})
export class ScheduledMessagesGQLService {
  private apollo = inject(Apollo);

  getUserQueueWithPagination(
    request: GetUserQueueWithPaginationQueryInput,
    fields: string[]
  ) {
    const query = gql`
    query getUserQueueWithPagination($request: GetUserQueueWithPaginationQueryInput) {
      getUserQueueWithPagination(request: $request) {
        items {
          ${fields.join('\n')}
        }
        totalCount
      }
    }
  `;
    return this.apollo
      .use(GraphqlClientType.ScheduledMessages)
      .watchQuery({
        query,
        variables: { request },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((res) => ({
          data: UtilService.deepRemovePropFormObject(
            res?.data?.['getUserQueueWithPagination'],
            '__typename'
          ),
        }))
      );
  }

  getUsersQueueWithPagination(
    request: GetUsersQueueWithPaginationQueryInput,
    fields: string[]
  ) {
    const query = gql`
    query getUsersQueueWithPagination($request: GetUsersQueueWithPaginationQueryInput) {
      getUsersQueueWithPagination(request: $request) {
        items {
          ${fields.join('\n')}
        }
        totalCount
      }
    }
  `;
    return this.apollo
      .use(GraphqlClientType.ScheduledMessages)
      .watchQuery({
        query,
        variables: { request },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((res) => ({
          data: UtilService.deepRemovePropFormObject(
            res?.data?.['getUsersQueueWithPagination'],
            '__typename'
          ),
        }))
      );
  }

  getResellerScheduledMessageWithPagination(
    request: GetResellerQueueWithPaginationQueryInput,
    fields: string[]
  ) {
    const query = gql`
    query getResellerScheduledMessageWithPagination($request: GetResellerQueueWithPaginationQueryInput) {
      getResellerScheduledMessageWithPagination(request: $request) {
        items {
          ${fields.join('\n')}
        }
        totalCount
      }
    }
  `;
    return this.apollo
      .use(GraphqlClientType.ScheduledMessages)
      .watchQuery({
        query,
        variables: { request },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((res) => ({
          data: UtilService.deepRemovePropFormObject(
            res?.data?.['getResellerScheduledMessageWithPagination'],
            '__typename'
          ),
        }))
      );
  }

  getCurrentUserQueueWithPagination(
    request: GetCurrentUserQueueWithPaginationQueryInput,
    fields: string[]
  ) {
    const query = gql`
    query getCurrentUserQueueWithPagination($request: GetCurrentUserQueueWithPaginationQueryInput) {
      getCurrentUserQueueWithPagination(request: $request) {
        items {
          ${fields.join('\n')}
        }
        totalCount
      }
    }
  `;
    return this.apollo
      .use(GraphqlClientType.ScheduledMessages)
      .watchQuery({
        query,
        variables: { request },
        fetchPolicy: 'network-only',
      })
      .valueChanges.pipe(
        map((res) => ({
          data: UtilService.deepRemovePropFormObject(
            res?.data?.['getCurrentUserQueueWithPagination'],
            '__typename'
          ),
        }))
      );
  }
}
